import { Injectable } from '@angular/core';

import { Question, QuestionKind } from '../../common/models/flow.dto';
import { genId } from '../../core/services/genId';

@Injectable()
export class BuilderService {

  constructor() { }

  generateReviewComments(): Array<Question> {
    const commentRow = new Array<Question>();
    const commentQuestion = {
      key: genId(),
      label: "Final Review Comments",
      type: QuestionKind.ReviewComments,
      defaultValue: "",
      validationRules: [],
      changeRules: [],
      notes: []
    } as Question;
    commentRow.push(commentQuestion);
    return commentRow;
  }

}
